import { api } from '@/apis';
import { encodeParams } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Polygon } from 'geojson';

export function useBoundary(type: string, id: string) {
  const queryKey = [type, id];
  const queryClient = useQueryClient();
  const query = useQuery<Polygon | undefined>({
    queryKey,
    queryFn: async ({ signal }) => {
      switch (type) {
        case 'Location': {
          const location = (await api
            .get(`locations/${id}`, {
              searchParams: encodeParams({ projection: { boundary: true } }),
              signal,
            })
            .json()) as { boundary: Polygon };

          return location?.boundary;
        }
        default:
          return;
      }
    },
    staleTime: 1000 * 60 * 60,
    enabled: !!type && !!id,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
